import React, { useEffect, useState } from 'react';
import HeroTextCarouselItem from './HeroTextCarouselItem';
import './HeroTextCarousel.scss';
import PropTypes from 'prop-types'; 

export default function HeroTextCarousel(props) {

    const [activeIndex, setActiveIndex] = useState(0);

    const cycleItem = () => {
        setActiveIndex((i) => {
            if ((i + 1) > (props.carouselItems.length - 1)) {
                return 0;
            } else {
                return i + 1;
            }
        });
    };

    useEffect(() => {
        const interval = setInterval(cycleItem, props.cycleTime);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="text-carousel-container">
            {props.carouselItems.map((item, i) => {
                return <HeroTextCarouselItem key={i} active={i === activeIndex} title={item.title} subtitle={item.subtitle} subtitleExtended={item.subtitleExtended} />
            })}
        </div>
     ); 
};

HeroTextCarousel.propTypes = {
    carouselItems: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string.isRequired,
        subtitleExtended: PropTypes.string.isRequired,
    })).isRequired,
    cycleTime: PropTypes.number.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/LandingPages/HeroImage/HeroTextCarousel.js